import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import Login from './Login';
import { Loader2 } from 'lucide-react';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredPermission?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  requiredPermission 
}) => {
  const { user, loading, session, hasPermission } = useAuth();

  // 1. Si loading === true → mostrar spinner, NO redirigir
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <Loader2 className="w-8 h-8 animate-spin text-indigo-600 mx-auto mb-4" />
          <p className="text-gray-600">Verificando sesión...</p>
        </div>
      </div>
    );
  }

  // 2. Esperar a que session sea distinto de "undefined"
  // Si session es undefined, aún estamos cargando (no debería pasar si loading es false, pero por seguridad)
  if (session === undefined) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <Loader2 className="w-8 h-8 animate-spin text-indigo-600 mx-auto mb-4" />
          <p className="text-gray-600">Cargando sesión...</p>
        </div>
      </div>
    );
  }

  // 3. Cuando session es null → redirigir al login
  if (session === null) {
    return <Login />;
  }

  // ✅ CORREGIDO: No redirigir si loading terminó y user es null
  // Solo redirigir si loading terminó Y user es null (no hay usuario temporal)
  // Si hay user temporal, permitir acceso
  if (!loading && user === null) {
    return <Login />;
  }

  // Si se requiere un permiso específico, verificar (solo si user ya está cargado)
  if (requiredPermission && user && !hasPermission(requiredPermission)) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center max-w-md p-6 bg-white rounded-lg shadow-lg">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Acceso Denegado</h2>
          <p className="text-gray-600 mb-4">
            No tienes permisos para acceder a esta sección.
          </p>
          <p className="text-sm text-gray-500">
            Contacta al administrador si necesitas acceso.
          </p>
        </div>
      </div>
    );
  }

  // Usuario autenticado y con permisos, mostrar contenido
  return <>{children}</>;
};

export default ProtectedRoute;

